import { createContext, useContext, useEffect, useState } from "react";
import { formatTimestamp } from "../utils/helper";
import { startOfYear, subMonths, subWeeks } from "date-fns";
import { sortBy } from "lodash";

import { toast } from "react-toastify";
import { machineProfile, location, user, auth } from "../api";
import { useAuth } from "./AuthContext";
import { parserAPI } from "../utils/parser";
import { getApp, setApp } from "../utils/browserStorage";

const DashboardContext = createContext({
  machines: [],
  locations: [],
  machineTypes: [],
  sublocations: [],
  machinaryClass: [],
  listGinaAction: [],
  dateRange: {
    startTs: subMonths(new Date(), 1),
    stopTs: new Date(),
  },
  dateRangeVariance: {
    startTs: formatTimestamp(subMonths(new Date(), 12)),
    stopTs: formatTimestamp(new Date()),
  },
  weeklyDate: {
    start: subWeeks(new Date(), 1),
    end: new Date(),
  },
  weeklyAnalytics: {
    sensor: null,
    threshold: null,
    chart: null,
  },
  selectedMachine: null,
  selectedLocation: null,
  relocateModal: false,
  userSetupCenter: "",
  selectedAnnotation: null,
  dateRangeOverview: null,
  selectedAxisContext: null,
  selectedLocationOverview: null,
  selectedMachineOverview: null,
  refreshAnnotation: 1,
  totalAPI: 0,
  progressAPI: 0,
  newAlert: null,
  selectedLocationDetail: {},
  ginaAction: {},
  ginaPosition: {},
  selectedSublocation: null,
  selectedStatusReport: null,
  selectedSublocationDetail: {},
  activeFilter: "location",
  updateStatusReport: (total) => {},
  updateSelectedLocationOverview: (location) => {},
  updateSelectedMachineOverview: (machine) => {},
  updateDateRangeOverview: (dates) => {},
  updateRelocateModal: (relocateModal) => {},
  updateWeeklyAnalytics: ({ sensor, threshold, chart }) => {},
  updateWeeklyDate: ({ start, end }) => {},
  updateSetupCenter: (data) => {},
  addTotalAPI: (total) => {},
  addProgressAPI: (total) => {},
  updateTotalAPI: (total) => {},
  updateActiveFilter: (filter) => {},
  selectMachine: (machine) => {},
  selectLocation: (location) => {},
  selectSublocation: (vesel) => {},
  selectSublocationDetail: (vesel) => {},
  triggerNotification: (notif) => {},
  updateMachines: (machine) => {},
  updateGinaPosition: (position) => {},
  updateGinaAction: (action) => {},
  updateListGinaAction: (action) => {},
  updateMachinaryClass: (machinary) => {},
  updateDateRange: (dateRange) => {},
  updateDateRangeVariance: (dateRangeVariance) => {},
  updateLocations: (location) => {},
  updateSublocations: (sublocation) => {},
  resetContext: () => {},
});
export const useDashboardContext = () => useContext(DashboardContext);

export function DashboardContextProvider(props) {
  const { isAuthenticated } = useAuth();
  const [weeklyDate, setWeeklyDate] = useState({
    start: subWeeks(new Date(), 1),
    end: new Date(),
  });
  const [weeklyAnalytics, setWeeklyAnalytics] = useState({
    sensor: null,
    threshold: null,
    chart: null,
  });
  const [machines, setMachines] = useState([]);
  const [relocateModal, setRelocateModal] = useState(false);
  const [selectedApp, setSelectedApp] = useState(getApp() || "CGM");
  const [locations, setLocations] = useState([]);
  const [activeFilter, setActiveFilter] = useState("location");
  const [userSetupCenter, setUserSetupCenter] = useState("");
  const [selectedLocationDetail, setSelectedLocationDetail] = useState({});
  const [machineTypes, setMachineTypes] = useState([]);
  const [ginaAction, setGinaAction] = useState(null);
  const [newAlert, setNewAlert] = useState(null);
  const [totalAPI, setTotalAPI] = useState(0);
  const [progressAPI, setProgressAPI] = useState(0);
  const [selectedSublocationDetail, setSelectedSublocationDetail] = useState(
    {}
  );
  const [sublocations, setSublocations] = useState([]);
  const [selectedStatusReport, setSelectedStatusReport] = useState([]);
  const [listGinaAction, setListGinaAction] = useState([]);
  const [machinaryClass, setMachinaryClass] = useState([]);
  const [dateRange, setDateRange] = useState({
    startTs: subMonths(new Date(), 1),
    stopTs: new Date(),
  });
  const [dateRangeVariance, setDateRangeVariance] = useState({
    startTs: formatTimestamp(subMonths(new Date(), 12)),
    stopTs: formatTimestamp(new Date()),
  });
  const [selectedMachine, setSelectedMachine] = useState(null);
  const [selectedAnnotation, setSelectedAnnotation] = useState(null);
  const [ginaPosition, setGinaPosition] = useState(null);
  const [refreshAnnotation, setRefreshAnnotation] = useState(1);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedSublocation, setSelectedSublocation] = useState(null);
  const [selectedAxisContext, setselectedAxisContext] = useState(null);
  const [dateRangeOverview, setDateRangeOverview] = useState({
    startDate: startOfYear(new Date()),
    endDate: new Date(),
  });
  const [selectedMachineOverview, setSelectedMachineOverview] = useState("");
  const [selectedLocationOverview, setSelectedLocationOverview] =
    useState(null);

  //GET ALL LOCATIONS
  async function getLocation() {
    try {
      // const res = await location.list();
      // const data = await parserAPI(res);
      setLocations([
        {
          id: "d60de1a2-e418-4da7-8924-5bf1bfb7dd6a",
          location_name: "HMID - Hyundai Motor Indonesia",
          company_id: "faf62221-5918-40a4-9d99-e58bac5cfb8b",
          contact_person: null,
          contact_email: null,
          contact_number: null,
          location_address: null,
          parent_location_id: null,
          picture_url: null,
          location_machine_health: null,
          location_machine_health_last_updated: null,
        },
      ]);
    } catch (e) {
      toast.error(e.message);
    }
  }

  //GET MACHINE TYPE
  async function getMachineType() {
    try {
      const res_classes = await machineProfile.listMachineClass();
      if (res_classes.ok) {
        const body = await res_classes.json();
        setMachineTypes(body.data);
      }
    } catch (e) {
      toast.error(e.message);
    }
  }
  const getProfile = async () => {
    const res = await auth.self();
    if (res.ok) {
      const body = await res.json();
      if (body.data) {
        const { user_setup_center } = body.data;
        if (user_setup_center) {
          updateSetupCenter(user_setup_center);
        }
      }
    }
  };
  const addSetupDone = async (setup) => {
    const res = await user.addSetupDone(setup);
    if (res.ok) {
      const body = await res.json();
      if (body.success) {
        getProfile();
      }
    }
    return "done";
  };
  useEffect(() => {
    if (isAuthenticated) {
      getProfile();
      getLocation();
      getMachineType();
    }
  }, [isAuthenticated]);

  function updateMachinesHandler(machines) {
    const sortedMachine = sortBy(machines, (obj) => {
      const arr = obj["name"].match(/[0-9]+$/);
      if (arr) {
        return parseInt(arr[0], 10);
      } else {
        return obj["name"];
      }
    });
    setMachines(sortedMachine);
  }
  function updateMachinaryClassHandler(machinary) {
    setMachinaryClass(machinary);
  }

  function updateMachineTypesHandler(machineTypes) {
    setMachineTypes(machineTypes);
  }

  function updateWeeklyAnalyticsHandler({ sensor, threshold, chart }) {
    // only update the state if the value is defined
    if (sensor || sensor === null)
      setWeeklyAnalytics({ ...weeklyAnalytics, sensor });
    if (threshold || threshold === null)
      setWeeklyAnalytics({ ...weeklyAnalytics, threshold });
    if (chart || chart === null)
      setWeeklyAnalytics({ ...weeklyAnalytics, chart });
  }

  function updateWeeklyDateHandler({ start, end }) {
    setWeeklyDate({
      start,
      end,
    });
  }

  function updateLocationsHandler(locations) {
    setLocations(locations);
  }
  function updateNewAlertHandler(alert) {
    setNewAlert(alert);
  }

  function updateTotalAPIHandler(total) {
    setTotalAPI(total);
  }
  function addTotalAPIHandler(total) {
    // add totalAPI with new total
    setTotalAPI(totalAPI + total);
  }

  function addProgressAPIHandler(progress) {
    setProgressAPI(progress);
  }

  function updateDateRangeOverviewHandler(dates) {
    setDateRangeOverview(dates);
  }

  function updateSelectedStatusReportHandler(status) {
    setSelectedStatusReport(status);
  }
  function updateRelocateModalHandler(relocateModal) {
    setRelocateModal(relocateModal);
  }

  function updateSublocationsHandler(sublocations) {
    setSublocations(sublocations);
  }
  function updateGinaPositionHandler(position) {
    setGinaPosition(position);
  }

  function updateDateRangeHandler(date) {
    setDateRange(date);
  }
  function updateDateRangeVarianceHandler(date) {
    setDateRangeVariance(date);
  }
  function updateSetupCenter(data) {
    setUserSetupCenter(data);
  }

  function updateSelectedLocationOverview(location) {
    setSelectedLocationOverview(location);
  }

  function updateSelectedMachineOverview(machine) {
    setSelectedMachineOverview(machine);
  }

  function prosesRefreshAnnotation() {
    setRefreshAnnotation(refreshAnnotation + 1);
  }

  function selectMachineHandler(machine) {
    setSelectedMachine(machine);
  }

  function updateAxis(axis) {
    setselectedAxisContext(axis);
  }

  function selectAnnotationHandler(annotation) {
    setSelectedAnnotation(annotation);
  }
  function updateGinaActionHandler(action) {
    setGinaAction(action);
  }
  function updateActiveFilterHandler(filter) {
    setActiveFilter(filter);
  }
  function updateListGinaActionHandler(actions) {
    setListGinaAction(actions);
  }

  function selectSublocationHandler(sublocation) {
    setSelectedSublocation(sublocation);
    const s = sublocations.find((f) => f.id === sublocation);
    if (s) setSelectedSublocationDetail(s);
  }

  function newNotification(message, subtitle) {
    // addNotification({
    //   title: title,
    //   vibrate: 4,
    //   icon: "./img/ai_face.png",
    //   onClick: () => {},
    //   subtitle: subtitle,
    //   message: message,
    //   theme: "darkblue",
    //   native: true,
    //   silent: false,
    // });
    toast.error(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });

    const getStatus = localStorage.getItem("gina_sound");
    if (getStatus === "1") {
      let sound;
      sound = new Audio();
      sound.src = "./audio/alert.mp3";
      sound.load();
      sound.play();
    }
  }

  function triggerNotification(notif) {
    newNotification(notif.message, notif.subtitle);
  }

  function selectSublocationDetailHandler(sublocation) {
    setSelectedSublocationDetail(sublocation);
  }

  function selectLocationHandler(location) {
    if (location) {
      setSelectedLocation(location.id);
      setSelectedLocationDetail(location);
    }
  }

  function handleChangeApp(app) {
    setSelectedApp(app);
    setApp(app);
  }

  function resetContextHandler() {
    console.log("reset context");
    setLocations([]);
    setSublocations([]);
    setSelectedLocation(null);
    setSelectedLocationDetail({});
    setSelectedSublocation(null);
    setSelectedSublocationDetail({});
  }
  const context = {
    machines: machines,
    locations: locations,
    sublocations: sublocations,
    dateRange: dateRange,
    weeklyDate: weeklyDate,
    weeklyAnalytics: weeklyAnalytics,
    newAlert: newAlert,
    dateRangeVariance: dateRangeVariance,
    ginaAction: ginaAction,
    selectedMachine: selectedMachine,
    selectedAnnotation: selectedAnnotation,
    selectedLocationDetail: selectedLocationDetail,
    selectedSublocationDetail: selectedSublocationDetail,
    selectedLocation: selectedLocation,
    listGinaAction: listGinaAction,
    selectedSublocation: selectedSublocation,
    ginaPosition: ginaPosition,
    activeFilter: activeFilter,
    machinaryClass: machinaryClass,
    selectedAxisContext: selectedAxisContext,
    machineTypes: machineTypes,
    refreshAnnotation: refreshAnnotation,
    totalAPI: totalAPI,
    progressAPI: progressAPI,
    userSetupCenter: userSetupCenter,
    selectedStatusReport: selectedStatusReport,
    relocateModal: relocateModal,
    dateRangeOverview: dateRangeOverview,
    selectedLocationOverview: selectedLocationOverview,
    selectedMachineOverview: selectedMachineOverview,
    updateSelectedLocationOverview: updateSelectedLocationOverview,
    updateSelectedMachineOverview: updateSelectedMachineOverview,
    updateDateRangeOverview: updateDateRangeOverviewHandler,
    updateRelocateModal: updateRelocateModalHandler,
    getProfile: getProfile,
    addSetupDone: addSetupDone,
    updateWeeklyAnalytics: updateWeeklyAnalyticsHandler,
    updateSetupCenter: updateSetupCenter,
    updateWeeklyDate: updateWeeklyDateHandler,
    updateStatusReport: updateSelectedStatusReportHandler,
    addTotalAPI: addTotalAPIHandler,
    updateTotalAPI: updateTotalAPIHandler,
    addProgressAPI: addProgressAPIHandler,
    RefreshAnnotation: prosesRefreshAnnotation,
    selectAnnotation: selectAnnotationHandler,
    selectAxisContext: updateAxis,
    updateNewAlert: updateNewAlertHandler,
    selectMachine: selectMachineHandler,
    updateGinaPosition: updateGinaPositionHandler,
    updateGinaAction: updateGinaActionHandler,
    updateActiveFilter: updateActiveFilterHandler,
    updateListGinaAction: updateListGinaActionHandler,
    selectSublocation: selectSublocationHandler,
    selectSublocationDetail: selectSublocationDetailHandler,
    selectLocation: selectLocationHandler,
    updateMachines: updateMachinesHandler,
    triggerNotification: triggerNotification,
    updateMachinaryClass: updateMachinaryClassHandler,
    updateLocations: updateLocationsHandler,
    updateSublocations: updateSublocationsHandler,
    updateDateRange: updateDateRangeHandler,
    updateDateRangeVariance: updateDateRangeVarianceHandler,
    updateMachineTypes: updateMachineTypesHandler,
    resetContext: resetContextHandler,
    selectedApp,
    handleChangeApp,
  };
  return (
    <DashboardContext.Provider value={context}>
      {props.children}
    </DashboardContext.Provider>
  );
}

export default DashboardContext;
